import {IMask, IMaskMixin} from 'react-imask';
import {validateCPF} from './validateCPF';

export const IDENTIFIER_LENGTH = {
	cpf: 11,
	carteirinha: 14,
	token: 7,
};

export const getLoginIdentifier = (loginData: string) => {
	let identifier = '0';

	if (!loginData) {
		return identifier;
	}

	if (loginData.includes('@')) {
		identifier = '3';
	}
	if (loginData.length === IDENTIFIER_LENGTH.cpf) {
		identifier = '1';
	}
	if (loginData.length === IDENTIFIER_LENGTH.carteirinha) {
		identifier = '2';
	}

	return identifier;
};

export const clearLoginMask = (data: string) => data.replace(/[-/.]/g, '');

export const masks = {
	login: {
		mask: [
			{
				mask: '000.000.000-00', // CPF
			},
			{
				mask: '#####.######/##-#', // Carteirinha
				definitions: {
					'#': /[A-Za-z0-9]/,
				},
			},
			{
				mask: 'w@w',
				blocks: {
					w: {mask: /[\w.-]*/g},
				}, // Email
			},
		],

		dispatch: (appended: string, dynamicMasked: typeof IMaskMixin.arguments) => {
			const currentValue = dynamicMasked.value + appended;

			if (validateCPF(currentValue)) {
				return dynamicMasked.compiledMasks[0];
			}

			if (/^\w{5}\w{6}\w{2}\w$/.test(currentValue)) {
				return dynamicMasked.compiledMasks[1];
			}

			return dynamicMasked.compiledMasks[2];
		},
	},
	register: {
		mask: [
			{
				mask: '000.000.000-00', // CPF
			},
			{
				mask: '#####.000000/00-0', // Carteirinha
				definitions: {
					'#': /[A-Za-z0-9]/,
				},
			},
		],
	},
	phone: {mask: '(00) 0000-0000'},
	cellphone: {mask: '(00) 00000-0000'},
	cpf: {mask: '000.000.000-00'},
	zipCode: {mask: '00000-000'},
	cnpj: ({alphaNumeric = false}: {alphaNumeric?: boolean}) =>
		alphaNumeric
			? {
					mask: 'AA.AAA.AAA/AAAA-00',
					definitions: {
						A: /[A-Za-z0-9]/,
					},
					prepare: (str: string) => str.toUpperCase(),
				}
			: {mask: '00.000.000/0000-00'},
	birthday: {
		overwrite: true,
		mask: 'dd/mm/yyyy',
		blocks: {
			dd: {
				mask: IMask.MaskedRange,
				from: 1,
				to: 31,
			},
			mm: {
				mask: IMask.MaskedRange,
				from: 1,
				to: 12,
			},
			yyyy: {
				mask: IMask.MaskedRange,
				from: 1900,
				to: 9999,
			},
		},
	},
	datePicker: {
		overwrite: true,
		mask: 'dd/mm/yyyy - dd/mm/yyyy',
		blocks: {
			dd: {
				mask: IMask.MaskedRange,
				from: 1,
				to: 31,
			},
			mm: {
				mask: IMask.MaskedRange,
				from: 1,
				to: 12,
			},
			yyyy: {
				mask: IMask.MaskedRange,
				from: 1900,
				to: 9999,
			},
		},
	},
	currency: {
		mask: Number,
		scale: 2,
		signed: false,
		thousandsSeparator: '.',
		padFractionalZeros: true,
		normalizeZeros: true,
		radix: ',',
		mapToRadix: ['.'],
	},
};
